import { render, staticRenderFns } from "./LoginMenu.vue?vue&type=template&id=08b04f09&scoped=true"
import script from "./LoginMenu.vue?vue&type=script&lang=js"
export * from "./LoginMenu.vue?vue&type=script&lang=js"
import style0 from "./LoginMenu.vue?vue&type=style&index=0&id=08b04f09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b04f09",
  null
  
)

export default component.exports